import { gql } from '@apollo/client';

/**
 * Query to fetch sites (fuel stations) with pagination
 * Sites include address and brand information
 */
export const GET_SITES_DATA_QUERY = gql`
	query sitesData($after: String, $before: String, $first: Int, $last: Int) {
		sites(after: $after, before: $before, first: $first, last: $last) {
			nodes {
				id
				name
				ownerId
				shortName
				address {
					city
					latitude
					longitude
					postalCode
					road
				}
				brand {
					id
					name
				}
			}
			pageInfo {
				endCursor
				hasNextPage
				hasPreviousPage
				startCursor
			}
		}
	}
`;
